import { Chip, Typography } from "@mui/material"

export const ticketLocationTypes = [
    {
        label: 'Customer',
        value: 'customer'
    },
    {
        label: 'Location',
        value: 'location'
    },
    {
        label: 'Company',
        value: 'company'
    },
    {
        label: 'Vendor',
        value: 'vendor'
    }
]

export const ticketStatuses = [
    {
        label: 'Assigned',
        value: 'assigned',
        color: '#4DA829'
    },
    {
        label: 'In Progress',
        value: 'inprogress',
        color: '#C98332'
    },
    {
        label: 'Picked',
        value: 'picked',
        color: '#858181'
    },
    {
        label: 'Dropped',
        value: 'dropped',
        color: '#2ba3b4'
    },
    {
        label: 'Returned',
        value: 'returned',
        color: '#F8C146'
    },
    {
        label: 'Completed',
        value: 'completed',
        color: '#4778B3'
    },
    // {
    //     label: 'Delayed',
    //     value: 'delayed',
    //     color: '#767676'
    // },
    {
        label: 'Rejected',
        value: 'rejected',
        color: '#CE342B'
    },
]
export const ticketClassStatuses = [
    {
        label: 'Current',
        value: 'current',
        color: '#3366FF'
    },
    {
        label: 'Previous',
        value: 'previous',
        color: '#919EAB'
    },
    {
        label: 'Upcoming',
        value: 'upcomming',
        color: '#3366FF'
    },

]
export const ticketTypes = [
    {
        label: 'Customer',
        value: '1'
    },
    {
        label: 'Internal',
        value: '2'
    },
]

export const crewStatuses = [
    {
        label: 'Active',
        value: 'active',
    },
    {
        label: 'In Active',
        value: 'in_active',
    },
];

export const tripItemTypes = [
    {
        label: 'Item',
        value: 'item'
    },
    {
        label: 'Equipment',
        value: 'equipment'
    },
]

export const renderStatus = (status, without = "") => {
    if (!status) return;
    const d = ticketStatuses.filter(item => item.value == status)
    if (without) {
        return <Typography sx={{ fontWeight: 800 }}>{d && d[0] && d[0].label}</Typography>
    } else {
        return <Chip label={d && d[0] && d[0].label} sx={{ backgroundColor: d && d[0] && d[0].color, color: '#ffff' }} />
    }
}

export const renderTicketType = (type) => {
    if (!type) return;
    if (type === '1') {
        return "Customer"
    } else {
        return "Internal"
    }
}

export const renderTripType = (id, tripTypes) => {
    if (!id) return;
    let tripName = tripTypes?.filter(type => type.id === parseInt(id)) || [];
    return tripName[0]?.name;
}

export const FilterTripItems = (data = [], type) => {
    if (!type) return;
    let val = [];
    const tripType = data?.trips?.trip_type?.name
    const typeWiseFilter = data?.trips?.trip_items.filter(item => item?.trip_mode === type);
    const findPickUp = data?.trips?.trip_items.filter(item => item?.trip_mode === "pickup");
    switch (tripType) {
        case 'Delivery':
            val = data?.trips?.trip_items;
            break;
        case 'Terminate':
            val = data?.trips?.trip_items;
            break;
        case 'Dump / Switch':
            val = type === "dropoff" ? findPickUp : typeWiseFilter;
            break;
        case 'Dump / Return':
            val = type === "dropoff" ? findPickUp : typeWiseFilter;
            break;
        case 'WTUL':
            val = data?.trips?.trip_items;
            break;
        case 'WTL':
            val = data?.trips?.trip_items;
            break;
        case 'HAUL/LOAD/UNLOAD':
            val = type === "dropoff" ? findPickUp : typeWiseFilter;
            break;
        case 'Relocate':
            val = data?.trips?.trip_items;
            break;
        case 'Pickup & Deliver':
            val = data?.trips?.trip_items;
            break;
        default:
            val = [];
    }
    // const d = data?.trips?.trip_items.filter(item => item?.trip_mode === type)
    return val;
}

export const RenderTicketScanFormField = (status, tripType) => {
    let showFormField = false
    if (tripType === "WTUL") {
        if (status === "dropped") {
            showFormField = true;
        }
    } else if (tripType === "WTL") {
        if (status === "picked") {
            showFormField = true;
        }
    } else if (tripType === "EQUIPMENT HAUL") {
        if (status === "picked" || status === "dropped") {
            showFormField = true;
        }
    }
    return showFormField;
}

export const RenderSurchargeStatus = (status, tripType) => {
    let newStatus = '';
    let removeSpace = tripType?.replace(/\s/g, "");
    const type = removeSpace?.toLowerCase();
    let showSurcharge = false;
    if (type === "dump/return" || type === "equipmenthaul" || type === "dump/switch") {
        if (status === "inprogress") {
            showSurcharge = true;
            newStatus = 'pick'
        } else if (status === "picked") {
            showSurcharge = true;
            newStatus = 'drop'
        }
    } else if (type === "wtl" || type === "wtul" || type === "relocate" || type === "pickup&deliver") {
        if (status === "inprogress") {
            newStatus = "pick"
            showSurcharge = true;
        } else if (status === "picked") {
            newStatus = "drop"
            showSurcharge = true;
        }
    } else if (type === "terminate") {
        if (status === "inprogress") {
            showSurcharge = true;
            newStatus = 'pick'
        }
    } else if (type === "delivery") {
        if (status === "inprogress") {
            showSurcharge = true;
            newStatus = 'drop'
        }
    }
    return { newStatus, showSurcharge };
}


export const RenderUpdatedStatus = (status, tripType) => {
    let newStatus = '';
    let removeSpace = tripType?.replace(/\s/g, "");
    const type = removeSpace?.toLowerCase();
    if (type === "dump/return" || type === "equipmenthaul" || type === "dump/switch") {
        if (status === "inprogress") {
            newStatus = 'picked'
        } else if (status === "picked") {
            newStatus = 'dropped'
        } else if (status === "dropped") {
            newStatus = 'returned'
        } else if (status === "returned") {
            newStatus = 'completed'
        }
    } else if (type === "wtl" || type === "wtul" || type === "relocate" || type === "pickup&deliver") {
        if (status === "inprogress") {
            newStatus = "picked"
        } else if (status === "picked") {
            newStatus = "dropped"
        } else if (status === "dropped") {
            newStatus = "completed"
        }
    } else if (type === "terminate") {
        if (status === "inprogress") {
            newStatus = 'picked'
        } else if (status === "picked") {
            newStatus = 'completed'
        }
    } else if (type === "delivery") {
        if (status === "inprogress") {
            newStatus = 'dropped'
        } else if (status === "dropped") {
            newStatus = 'completed'
        }
    }
    return newStatus;
}
